export default "__VITE_PUBLIC_ASSET__fb56d5ee__"